import DistributorLayout from '@/layouts/DistributorLayout.vue'
import PublicLayout from '@/layouts/PublicLayout.vue'

export default [
  {
    path: '/repair-files/:repairFileBoomerangId/client-return-transport',
    name: 'repairFileClientReturnTransport',
    component: () =>
      import('@/views/restricted/repair-files/RepairFileClientReturnTransportView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      hideHeader: true,
      permissions: ['DISTRIBUTOR_UPDATE_REPAIR_FILE'],
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/public/repair-prospect/add-document',
    name: 'repairFileProspectAddDocument',
    component: () =>
      import('@/views/public-access/repair-module/RepairFileProspectAddDocumentView.vue'),
    meta: { requiresAuth: false, publicCapability: true, layout: PublicLayout }
  },
  {
    path: '/repair-files/:repairFileBoomerangId',
    name: 'repairFileDetail',
    component: () => import('@/views/restricted/repair-files/RepairFileDetailView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      hideHeader: true,
      permissions: ['DISTRIBUTOR_VIEW_REPAIR_FILE'],
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/repair-file-detail/:repairFileBoomerangId',
    redirect: (to) => ({
      name: 'repairFileDetail',
      params: to.params,
      query: to.query,
      hash: to.hash
    })
  },
  {
    path: '/public/client-package-select',
    name: 'estimatePackageClientOptionSelected',
    component: () =>
      import('@/views/public-access/repair-module/EstimatePackageClientOptionSelected.vue'),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  },
  {
    path: '/public/client-option-select',
    name: 'estimateRepairerClientOptionSelected',
    component: () =>
      import('@/views/public-access/repair-module/EstimateRepairerClientOptionSelected.vue'),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  },
  {
    path: '/public/repair-file/add-attachment',
    name: 'repairFileAddAttachment',
    component: () => import('@/views/public-access/repair-module/RepairFileAddAttachmentView.vue'),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  },
  {
    path: '/public/repair-file/upload-additional-attachment',
    name: 'repairFileUploadAdditionalAttachment',
    component: () =>
      import('@/views/public-access/repair-module/RepairFileUploadAdditionalAttachmentView.vue'),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  },
  {
    path: '/public/product-request/upload-nameplate',
    name: 'productRequestUploadNameplate',
    component: () =>
      import('@/views/public-access/repair-module/ProductRequestUploadNameplateView.vue'),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  }
]
